<template>
  <Dialog
    v-model:visible="visible"
    :style="{ width: '450px' }"
    header="Export Questions"
    :modal="true"
  >
    <div class="field">
      <label for="exportGroup">Group</label>
      <Dropdown
        id="exportGroup"
        v-model="exportGroupId"
        :options="groups"
        option-label="title"
        option-value="id"
        placeholder="All groups"
        show-clear
        fluid
      />
      <small class="block mt-2 text-color-secondary">
        Leave empty to export questions from all groups.
      </small>
    </div>
    <template #footer>
      <Button
        label="Cancel"
        icon="pi pi-times"
        class="p-button-text"
        :disabled="exporting"
        @click="visible = false"
      />
      <Button
        label="Export"
        icon="pi pi-download"
        class="p-button-text"
        :loading="exporting"
        @click="exportToCsv"
      />
    </template>
  </Dialog>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'primevue/usetoast'

const visible = defineModel('visible', { type: Boolean, default: false })

const store = useStore()
const toast = useToast()

const groups = computed(() => store.state.groups.items)

const exportGroupId = ref(null)
const exporting = ref(false)

watch(visible, open => {
  if (open) exportGroupId.value = null
})

function slugify (value) {
  return String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'group'
}

async function exportToCsv () {
  exporting.value = true
  try {
    const blob = await store.dispatch('questions/exportQuestions', { groupId: exportGroupId.value || '' })

    const group = groups.value.find(g => g.id === exportGroupId.value)
    const scope = group ? slugify(group.title) : 'all'

    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `questions-${scope}.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)

    visible.value = false
    toast.add({ severity: 'success', summary: 'Successful', detail: 'Questions Exported', life: 3000 })
  } catch (err) {
    toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to export questions', life: 3000 })
    console.error('Export error:', err)
  } finally {
    exporting.value = false
  }
}
</script>
